@if (isExpandable) {
    <lib-button
        [kind]="ButtonKind.Link"
        [size]="ButtonSize.Large"
        (clicked)="ToggleShow($event)">
        <ng-container label>
            @if (!isShowLess) {
                <ng-container i18n="@@CommonShowMoreButton">Show More</ng-container>
            }
            @if (isShowLess) {
                <ng-container i18n="@@CommonShowLessButton">Show Less</ng-container>
            }
        </ng-container>
    </lib-button>
}